import type { AccessibilityTag } from "../types/accessibility";

type SmartTagLike = Pick<AccessibilityTag, "approved_for_public"> & {
  user_roles?: { isGeneralUser?: boolean } | null;
};

/**
 * A tag the AI produced: contributed by a general user and published.
 *
 * Team and mapper tags are recorded on site by a person, and unapproved tags are
 * not on the front end at all, so the pair identifies AI output without needing a
 * per-row origin column. Mirrors the general-user/approved test the accessibility
 * lists already filter on.
 */
export const isSmartTag = (tag: SmartTagLike): boolean =>
  tag?.user_roles?.isGeneralUser === true && tag?.approved_for_public === true;

/**
 * True when a space carries any general-user tag. Those spaces are AI-tagged in
 * practice, and testing for "every tag" would never pass: each space also holds the
 * category-type tag ("Main entrance"), which a person set and the AI never produces.
 */
export const isSmartTaggedSpace = (tags: SmartTagLike[] | undefined): boolean =>
  Array.isArray(tags) && tags.some(isSmartTag);
